import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { webddn } from 'src/environments/webddn';
import { content } from 'src/environments/data';
import { UserService } from './services/user.service';
import { parseDdnSession } from './utils/ddn-session';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  app_type = webddn.APP_TYPE;
  webddn_login_path = content.WEBDDN_LOGIN_PATH;    

  constructor(
    private cookieService: CookieService,
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const session = parseDdnSession(this.cookieService.get('ddnsession'));
    const memoryUser = this.userService.getCurrentUser();
    const hasSession = !!(session?.token || memoryUser?.token);

    if (hasSession) {
      const cookie = session?.token
        ? session
        : memoryUser?.token
          ? memoryUser
          : null;
      if (cookie) {
        // Restrict unapproved managers to /profile only
        try {

          // Gate any pending (manual-approval) account to /profile. Auto-approved users have
          // is_active:true; admins (s/a) bypass. Mirrors Approval Config manual vs auto.
          if (!cookie.is_active && cookie.role !== 's' && cookie.role !== 'a' && state.url !== '/profile') {
            this.router.navigate(['/profile']);
            return false;
          }
          // Force practitioners without schedule to /my-schedule
          if ((cookie.role === 'b' || cookie.role === 't' && this.app_type !== 'sport') && cookie.has_schedule === false
              && state.url !== '/my-schedule' && state.url !== '/profile') {
            this.router.navigate(['/my-schedule']);
            return false;
          }
        } catch (e) {}
      }

      console.log('AuthGuard: User has session, allowing access');
      return true;
    }

    console.log('AuthGuard: No session found, redirecting to login');
    this.router.navigate([this.webddn_login_path]);
    return false;
  }
}

/**
 * Modern Functional Route Guard for Angular 22
 */
export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(AuthGuard).canActivate(route, state);
};

